<template>
    <div>
        <p>About TACET</p>
       <video id="vr-video" :height="getWindowHeight()" :width="getWindowWidth()" autoplay muted>
           <source src="../assets/tacet-acronym-video.mp4">
       </video>
       <div class="content">
        <vs-row justify="center">
            <vs-col w="4">
                <div class="card-content">
                    <vs-card type="3">
                        <template #title>
                            <h3>Innovation from every angle</h3>
                        </template>
                        <template #img>
                            <!--<img src="../assets/eyetracking-gif.gif" alt="">-->
                        </template>
                        <template #text>
                            <p>
                                Partners Aquila Jet Training and Cineon Training are working together with expert input from the University of Exeter to bring a new perspective to airline training using VR incorporating eye tracking technology.  
                            </p>
                        </template>
                    </vs-card>
                </div>
            </vs-col>
            <vs-col w="4">
                <div class="card-content">
                    <vs-card type="3">
                        <template #title>
                            <h3>Training for Competency</h3>
                        </template>
                        <template #img>
                            <img src="/foto5.png" alt="">
                        </template>
                        <template #text>
                            <p>
                                We have exploited the opportunities to develop expertise for pilots based on the competency based approach adopted by ICAO. IATA and most of the world’s airlines.
                            </p>
                        </template>
                    </vs-card>
                </div>
            </vs-col>
            <vs-col w="4">
                <div class="card-content">
                    <vs-card type="3">
                        <template #title>
                            <h3>On the edge of Technology</h3>
                        </template>
                        <template #img>
                            <img src="/foto5.png" alt="">
                        </template>
                        <template #text>
                            <p>
                                TACET allows trainees to assess and develop their own competency based performance within the VR environment by means of an unique user interface and voice recording facility.
                                <br>
                                The entire training session can be downloaded to a training pilot for further analysis and feedback

                            </p>
                        </template>
                    </vs-card>
                </div>
            </vs-col>
        </vs-row>
       </div>
    </div>
</template>

<script>
export default {
    name: "About",
    methods: {
        getWindowHeight() {
            return window.innerHeight/2;
        },
        getWindowWidth() {
            return window.innerWidth/2;
        }
    }
}
</script>

<style scoped>
video{
    margin-top: 5px;
}
vs-row{
    align-self: center;
}
</style>